import React from "react";
import styles from "./Familie.module.css";

import A0Main from "../../../assets/brochure/familie/A_0_main.webp";

import Asset2 from "../../../assets/brochure/familie/Asset 2.webp";
import Asset3 from "../../../assets/brochure/familie/Asset 3.webp";
import Asset4 from "../../../assets/brochure/familie/Asset 4.webp";

import Page03Bg from "../../../assets/brochure/familie/A_02_2_v3.webp";

import Page04Bg from "../../../assets/brochure/familie/A_03.webp";

import Asset6 from "../../../assets/brochure/familie/Asset 6.webp";
import Asset7 from "../../../assets/brochure/familie/Asset 7.webp";
import Asset8 from "../../../assets/brochure/familie/Asset 8.webp";
import Asset9 from "../../../assets/brochure/familie/Asset 9.webp";
import Asset10 from "../../../assets/brochure/familie/Asset 10.webp";

import Asset11 from "../../../assets/brochure/familie/Asset 11.webp";
import Asset12 from "../../../assets/brochure/familie/Asset 12.webp";
import Asset13 from "../../../assets/brochure/familie/Asset 13.webp";
import Asset14 from "../../../assets/brochure/familie/Asset 14.webp";
import Asset15 from "../../../assets/brochure/familie/Asset 15.webp";
import Asset16 from "../../../assets/brochure/familie/Asset 16.webp";

import Page06Bg from "../../../assets/brochure/familie/A_05.webp";
import Familie02 from "../../../assets/brochure/familie/Familie_02.png";
import Familie07 from "../../../assets/brochure/familie/Familie_07.jpg";

const Familie = () => {
  return (
    <article className={styles.familieBrochure}>


<section className={styles.page01}>

  <img
    src={A0Main}
    alt="FAMILIE Massage Sofa"
    className={styles.page01MainImage}
  />

  <div className={styles.page01Text}>
    <h2>
      <strong>FAMILIE,</strong> a wonderful relaxation alone
    </h2>

    <p>
      On top of the terra brown color and simple design,
      <br />
      BODYFRIEND’s proprietary massage technology completes
      <br />
      perfect relaxation alone.
    </p>
  </div>

</section>



<section className={styles.page02}>

  <header className={styles.page02Header}>
    <p className={styles.page02Eyebrow}>
      Massage sofa
    </p>

    <h2 className={styles.page02Wordmark}><img src={Familie02} alt="FAMILIE" /></h2>

    <p className={styles.page02Subtitle}>
      perfect for single-life
    </p>
  </header>


  <img
    src={Familie02}
    alt="FAMILIE massage sofa"
    className={styles.page02Chair}
    loading="lazy"
  />


  <div className={styles.page02Features}>

    <div className={styles.page02Feature}>
      <img
        src={Asset2}
        alt=""
        aria-hidden="true"
        className={styles.page02Icon}
      />

      <p>
        The massage sofa was born with massage
        <br />
        functions in a comfortable sofa.
      </p>
    </div>


    <div className={styles.page02Feature}>
      <img
        src={Asset3}
        alt=""
        aria-hidden="true"
        className={styles.page02Icon}
      />

      <p>
        With a length of 70cm and a weight
        <br />
        of 55kg, it is easy to utilize space and
        <br />
        move around.
      </p>
    </div>


    <div className={styles.page02Feature}>
      <img
        src={Asset4}
        alt=""
        aria-hidden="true"
        className={styles.page02Icon}
      />

      <p>
        Its simple design creates a harmonious
        <br />
        interior in any space.
      </p>
    </div>

  </div>

</section>


<section className={styles.page03}>

  <img
    src={Page03Bg}
    alt="FAMILIE compact size, color design and massage sofa features"
    className={styles.page03Bg}
    loading="lazy"
  />

  
  <div className={styles.page03CompactText}>
    <h3>Compact size for efficient space utilization</h3>

    <p>
      Its size and weight are reduced to a length of 70cm and a
      <br />
      weight of 55kg, making it easy to move freely and
      <br />
      utilize space.
    </p>
  </div>


  
  <div className={styles.page03ColorText}>
    <h3>
      Terra brown color
      <br />
      and simple design
    </h3>

    <p>
      The luxurious terra-brown color
      <br />
      harmonizes with the interior
      <br />
      and the easy-clean PU material
      <br />
      makes it easy to care for.
    </p>
  </div>


  
  <div className={styles.page03MassageText}>
    <h3>
      Massage and put
      <br />
      it back.
    </h3>

    <p>
      If you need a massage when
      <br />
      using it as a sofa, turn the
      <br />
      rotating leg massager to
      <br />
      massage your legs.
    </p>

    <small>
      * When you use the product as a sofa,
      <br />
      the calf massage function does not work.
    </small>
  </div>

</section>



<section className={styles.page04}>

  <img
    src={Page04Bg}
    alt="FAMILIE Check Point"
    className={styles.page04Bg}
    loading="lazy"
  />

  
  <div className={styles.page04Title}>
    <h2>
      <strong>FAMILIE, your own</strong>
      <br />
      massage sofa. Recommending it to
      <br />
      these people!
    </h2>
  </div>


  
  <div className={styles.page04List}>

    <div className={styles.page04Item}>
      <span className={styles.page04Check}>✓</span>
      <p>Those who enjoy single life in their own home</p>
    </div>

    <div className={styles.page04Item}>
      <span className={styles.page04Check}>✓</span>
      <p>Those who don’t need a sofa for more than 2 people</p>
    </div>

    <div className={styles.page04Item}>
      <span className={styles.page04Check}>✓</span>
      <p>
        Those who look for a second chair in the living room
        <br />
        or family room
      </p>
    </div>

    <div className={styles.page04Item}>
      <span className={styles.page04Check}>✓</span>
      <p>
        Those who need a chair for their bedroom,
        <br />
        study, or other private space
      </p>
    </div>

    <div className={styles.page04Item}>
      <span className={styles.page04Check}>✓</span>
      <p>Those who want to relax alone without being distracted</p>
    </div>

    <div className={styles.page04Item}>
      <span className={styles.page04Check}>✓</span>
      <p>
        Those who want to enjoy the best massage even in a
        <br />
        confined space
      </p>
    </div>

  </div>

</section>


<section className={styles.page05}>

  <header className={styles.page05Header}>
    <p>So compact, yet so powerful</p>

    <h2>
      The right size for small spaces
      <br />
      without sacrificing performance!
    </h2>
  </header>


  
  <article className={styles.page05Feature}>
    <img
      src={Asset6}
      alt="FAMILIE massage module"
      className={styles.page05Image}
      loading="lazy"
    />

    <div className={styles.page05Text}>
      <h3>
        <span>01.</span>
        World No. 1 BODYFRIEND’s technology is
        <br />
        fully embedded in the
      </h3>

      <strong className={styles.page05Highlight}>
        massage sensation.
      </strong>

      <p>
        The massage module, implemented with BODYFRIEND’s
        <br />
        proprietary technology, provides optimized massage.
      </p>
    </div>
  </article>


  
  <article className={styles.page05Feature}>
    <img
      src={Asset7}
      alt="FAMILIE calf airbag massage"
      className={styles.page05Image}
      loading="lazy"
    />

    <div className={styles.page05Text}>
      <h3>
        <span>02.</span>
        Powerful massage technique.
      </h3>

      <strong className={styles.page05Highlight}>
        Intensive care even for your calves!
      </strong>

      <p>
        The airbag massage intensively cares for your
        <br />
        calves that are easily swollen and tired.
      </p>
    </div>
  </article>


  
  <article className={styles.page05Feature}>
    <img
      src={Asset8}
      alt="FAMILIE customized massage program"
      className={styles.page05Image}
      loading="lazy"
    />

    <div className={styles.page05Text}>
      <h3>
        <span>03.</span>
        Different fatigue every day, differently each day.
      </h3>

      <strong className={styles.page05Highlight}>
        Condition-customized massage program
      </strong>

      <p>
        Customized massage is provided with 4 automatic
        <br />
        and 5 manual modes.
      </p>

<small className={styles.page05Modes}>
  - Automatic Mode: Neck/Shoulders, Back/Waist,
  
  Full Body Relaxation, and Full Body Refresh
  <br />
  - Manual Mode: Kneading, Tapping, Combination,
  
  Chopping, and Acupressure
</small>
    </div>
  </article>


  
  <article className={styles.page05Feature}>
    <img
      src={Asset9}
      alt="FAMILIE zero gravity mode"
      className={styles.page05Image}
      loading="lazy"
    />

    <div className={styles.page05Text}>
      <h3>
        <span>04.</span>
        Comfort even gravity cannot interfere with.
        <br />
        Zero gravity mode and angle adjustment
      </h3>

      <strong className={styles.page05Highlight}>
        Designed ergonomically, it provides comfort
        <br />
        that embraces the entire body.
      </strong>

      <p>
        The zero gravity mode tilting up to 136° evenly
        <br />
        distributes your weight for maximized massage sensation and provides
        <br />
        optimal relaxation with the best fit and comfort.
      </p>
    </div>
  </article>


  
  <article className={styles.page05Feature}>
    <img
      src={Asset10}
      alt="FAMILIE anti-fouling fabric"
      className={styles.page05Image}
      loading="lazy"
    />

    <div className={styles.page05Text}>
      <h3>
        <span>05.</span>
        Anti-fouling fabric. Easy to prevent and
      </h3>

      <strong className={styles.page05Highlight}>
        remove contamination
      </strong>

      <p>
        Anti-fouling and easy-to-clean properties help keep the material clean
        <br />
        for a long time, extending the product’s service life.
      </p>
    </div>
  </article>



</section>


<section
  className={styles.page06}
  aria-labelledby="familie-page06-title"
>
  <img src={Page06Bg} alt="" className={styles.page06Bg} />
  <header className={styles.page06Header}>
    <h2 id="familie-page06-title">
      <strong>FAMILIE’s</strong> own convenient features
      <br />
      that add complete relaxation
    </h2>
  </header>


  
  <article className={styles.page06Feature}>
    <div className={styles.page06Card}>

      <div className={styles.page06CardInfo}>
        <img
          src={Asset12}
          alt=""
          aria-hidden="true"
          className={styles.page06Icon}
          loading="lazy"
        />

        <h3>Bluetooth Speaker</h3>
      </div>

      <div className={styles.page06ImageWrap}>
        <img
          src={Asset11}
          alt="FAMILIE Bluetooth speaker"
          className={styles.page06Image}
          loading="lazy"
        />
      </div>

    </div>

    <p className={styles.page06Description}>
      With the Bluetooth connection, you can play
      <br />
      music through the speaker.
    </p>
  </article>


  
  <article className={styles.page06Feature}>
    <div className={styles.page06Card}>

      <div className={styles.page06CardInfo}>
        <img
          src={Asset14}
          alt=""
          aria-hidden="true"
          className={styles.page06Icon}
          loading="lazy"
        />

        <h3>USB charging port</h3>
      </div>

      <div className={styles.page06ImageWrap}>
        <img
          src={Asset13}
          alt="FAMILIE USB charging port"
          className={styles.page06Image}
          loading="lazy"
        />
      </div>

    </div>

    <p className={styles.page06Description}>
      Enjoy massage while charging your electronic device.
    </p>
  </article>


  
  <article className={styles.page06Feature}>
    <div className={styles.page06Card}>

      <div className={styles.page06CardInfo}>
        <img
          src={Asset16}
          alt=""
          aria-hidden="true"
          className={styles.page06Icon}
          loading="lazy"
        />

        <h3>Safe use</h3>
      </div>

      <div className={styles.page06ImageWrap}>
        <img
          src={Asset15}
          alt="FAMILIE leg pinch safety sensor"
          className={styles.page06Image}
          loading="lazy"
        />
      </div>

    </div>

    <p className={styles.page06Description}>
      With the sensor that detects leg pinch, you can use it safely.
    </p>
  </article>

</section>

<section className={styles.page07}>
  <img
    src={Familie07}
    alt="FAMILIE"
    className={styles.page07Image}
    loading="lazy"
  />
</section>
    </article>
  );
};

export default Familie;